import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
	BrowserRouter as Router,
	Route,
	Switch,
	Redirect,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import Data from './Data';
import Event from './Event';
import PublicEvent from './PublicEvent';
import Archive from './Archive';
import Duplicados from './Duplicados';
import Profile from './Profile';
import NotFound from './NotFound';
import Empty from './Empty';

const GoogleAnalyticsListener = () => {
	const location = useLocation();
	useEffect(() => {
		const pagePath = location.pathname;
		// Wait for document.title to update (max 200ms)
		let attempts = 0;
		const maxAttempts = 10;
		const interval = 20;
		const expectedTitle = document.title;
		const sendTracking = () => {
			const pageTitle = document.title;
			if (typeof window.sendPageView === 'function') {
				window.sendPageView(pagePath, pagePath || pageTitle);
			} else if (typeof window.gtag === 'function') {
				console.log('[GA Debug] Fallback: Sending page view:', {
					page_path: pagePath,
					page_title: pagePath || pageTitle,
					screen_name: pagePath || pageTitle
				});
				window.gtag('config', 'G-SDVJ249QB5', {
					page_path: pagePath,
					page_title: pagePath || pageTitle,
					screen_name: pagePath || pageTitle
				});
			}
		};
		const waitForTitle = () => {
			attempts++;
			// If title changed or max attempts reached, send tracking
			if (document.title !== expectedTitle || attempts >= maxAttempts) {
				sendTracking();
			} else {
				setTimeout(waitForTitle, interval);
			}
		};
		waitForTitle();
	}, [location]);
	return null;
};

const MainMenu = () => {
	const authenticated = useSelector((state) => state.auth.authenticated);
	
	const PrivateRoute = ({ component: Component, ...rest }) => {
		return (
			<Route
				{...rest}
				render={(props) =>
					authenticated ? <Component {...props} /> : <Redirect to="/" />
				}
			/>
		);
	};

   return (
	  <Router basename="/app">
		   <GoogleAnalyticsListener />
		   <Switch>
			   <Route exact path="/" render={() => (
				   authenticated ? <Redirect to="/evento" /> : <Redirect to="/eventoPublico" />
			   )} />
			   <Route path="/eventoPublico" component={PublicEvent} />
			   <Route path="/empty" component={Empty} />
			   <PrivateRoute path="/evento" component={Event} />
			   <PrivateRoute path="/archivo" component={Archive} />
			   <PrivateRoute path="/duplicados" component={Duplicados} />
			   <PrivateRoute path="/perfil" component={Profile} />
			   <Route path="*" component={NotFound} />
		   </Switch>
	   </Router>
   );
};

export default MainMenu;
